import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="M26 8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h20Zm-14 4.265a2.023 2.023 0 0 0-2 0 1.97 1.97 0 0 0-1 1.709v.402c.017.725.325 1.415.857 1.915-.193.03-.557.11-.57.112C7.931 16.72 7 17.396 7 18.183v2.253c0 .312.256.564.571.564h6.858a.568.568 0 0 0 .571-.564v-2.253c0-.787-.932-1.464-2.286-1.78l-.571-.112c.53-.502.838-1.19.857-1.915v-.402a1.97 1.97 0 0 0-1-1.71ZM18 19a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm0-3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm0-4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z" clip-rule="evenodd" stroke="none"></path>';
export var IdCardSVG = function IdCardSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
IdCardSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(IdCardSVG);